module.exports = __webpack_public_path__ + "img/FGr_Räumen_C.ef88712a.svg";